import { SharedIcon } from 'components/SharedIcon/SharedIcon';
const PlanningObjectives: React.FC = () => {
  return (
    <div className="planning-widget p-3">
      <h3 className="mt-0">
        <SharedIcon iconName="track_changes" classes="me-2" />
        Objectives
      </h3>
      <div className="text-weak mb-3">
        Review and finalize incident objectives for the operational period
      </div>
      <div className="section-main d-flex flex-column align-items-center">
        <div className="d-flex justify-content-center">
          <SharedIcon iconName="track_changes" classes="me-2" size="lg" />
        </div>
        <div>
          <div className="fs-5 mb-2">Objectives</div>
          <div className="mb-2">
            Objectives review functionality coming soon
          </div>
          <div>
            This will provide comprehensive objectives management including
            priority setting, resource allocation, and success metrics for the
            IAP.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanningObjectives;
